import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { type ExploitMaturity, IssueFilterKeys } from '../../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { useSetFilterHasChanged } from '../../../../redux/savedFilters/hooks';
import { FilterPanel } from '../../../generic/Filter';
import FilterCardCheckboxes from '../../../generic/Filter/FilterCardCheckboxes';
import useFetchIssuesAction from '../../IssuesInbox/hooks/useFetchIssuesAction';
import type { SelectOption } from '../../../../types';
import type { SelectedOptionsProps } from '../../../generic/Filter';

const FILTER_OPTIONS: SelectOption[] = [
  { value: 'has_known_exploit', label: 'Known Exploit' },
  { value: 'no_known_exploit', label: 'No Known Exploit' },
];

/**
 * Add a series of checkboxes for filtering Vuln Issues by "Exploit Maturity".
 */
const ExploitMaturityFilter: VoidFunctionComponent<Omit<SelectedOptionsProps, 'onSelect'>> = ({ selectedOptions }) => {
  const setFilters = useFetchIssuesAction(IssuesV2Store.actions.setFilter);
  const stateFilters = useSelector(IssuesV2Store.selectors.getFilter);
  const setFilterHasChanged = useSetFilterHasChanged();

  const selectedCheckboxes = (selectedOptions ?? []).map((option: string) => ({
    label: FILTER_OPTIONS.find(filterOption => filterOption.value === option)?.label || option,
    value: option,
  }));

  const onCheckboxChange = (newSelected: SelectOption[]) => {
    setFilters({
      ...stateFilters,
      [IssueFilterKeys.ExploitMaturity]: newSelected.map(({ value }) => value as ExploitMaturity),
    });
    setFilterHasChanged(true);
  };

  return (
    <FilterPanel>
      <FilterCardCheckboxes
        label="Exploit Maturity"
        options={FILTER_OPTIONS}
        values={selectedCheckboxes}
        onChange={onCheckboxChange}
        testId="issues-vuln-exploit-maturity"
      />
    </FilterPanel>
  );
};

export default ExploitMaturityFilter;
